/*
import {
  hf,
  hfDTM,
  hfXLS,
  ht,
  gs,
  cmPDF,
  _cv_60___Mz,
} from 'lib';
*/
import * as cmPDF from "./_cmPDF";
import * as gs from "./_csGbl";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import * as icvI1z___Mz from './icvI1z___Mz';

export const eptPdfAsync1 = async (pz: { // 利用申請書
  i1zr_fsts: ht.ls, // 複数出力への対応
  ttl?: ht.s, // title
}): Promise<ht.s|undefined> => {

  if (!hf.f(pz.i1zr_fsts)) return undefined; // 出力対象のデータなし

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

  let _lines = [] as ht.ls;

  await hf.ectSrlAsync(pz.i1zr_fsts.map((_i1zr_fst: ht.n, _i1zrIdx: ht.n) => (

    async () => {

      const _i1zz = await icvI1z___Mz.loadI1zrDzAsync({
        i1zr_fst: _i1zr_fst
      });

      const _i1zrz = _i1zz.i1zrz;
      const _i1z1s = _i1zz.i1z1s;
      const _i1z2s = _i1zz.i1z2s;
      const _i1z3z = _i1zz.i1z3z;
      const _i18rz = _i1zz.i18rz;

      let _row: ht.n;

      _row = 0;
      _lines.push({ type: 'text', pfx: `第１号様式`,  cmn: 1, row: _row, rowCnt: 1, ts: 0.8, });

      _row += 1;
//      _lines.push({ type: 'text', pfx: `${_gUserz.crt._31rz._pfx}　利用申請書`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 2, ta: 'ctr', frm: false, ts: 1.2, tb: true });
      _lines.push({ type: 'text', pfx: `${_gStgz.crt.S06041331 ?? ''}　利用申請書`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 2, ta: 'ctr', frm: false, ts: 1.2, tb: true });

      _row += 3;
      //hf.l(`icvI1z___Ez 40: ${_i1zrz._icn}`)
      _lines.push({ type: 'text', pfx: `予約ID: ${_i1zrz._icn}`,  cmn: 1, row: _row, rowCnt: 1, });
      _lines.push({ type: 'text', pfx: `申込日: ${hfDTM.f(_i1zrz.i1zrd2100s, '年月日', false)}`,  cmn: 36, row: _row, cmnCnt: 19, ta: 'rht', rowCnt: 1, });

      _row += 2;
      String(_gStgz.crt.S06041111).split(/\n/).map( _frmMsg1 => {
        _lines.push({ type: 'text', pfx: _frmMsg1,  cmn: 1, row: _row, tc: _gStgz.crt.S06041121 });
        _row += 1;
      });

      _row += 1;
      _lines.push({ type: 'text', pfx: `団体名`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${_i18rz._pfx.substring(0,30)}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;
      _lines.push({ type: 'text', pfx: `団体番号`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${_i18rz.i18rab100s}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;
/*
      _lines.push({ type: 'text', pfx: `申請者及び連絡先`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `申込者：${_i1zrz.i1zra2100s}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _lines.push({ type: 'text', pfx: `連絡先：${_i1zrz.i1zra3100s}`,  cmn: 34, row: _row, cmnCnt: 21, rowCnt: 1.5, ta: 'left', frm: false });
      _row += 1.5;
*/

/*
      _row += 1;
      String(_gStgz.crt.S06041211).split(/\n/).map( _frmMsg2 => {
      hf.l(`icvI1z___Ez 64: ${_frmMsg2}`)
        //_lines.push({ type: 'text', pfx: _frmMsg2,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 1, ta: 'ctr', tc: _gStgz.crt.S06041221 });
        _lines.push({ type: 'text', pfx: _frmMsg2,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 1, ta: 'ctr', tc: _gStgz.crt.S06041221 });
        _row += 1;
      });
*/

      _row += 1;
      _lines.push({ type: 'text', pfx: `利用日`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${hfDTM.f(_i1zrz.i1zrd3100s, '年月日（曜日）', true)}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;
      _lines.push({ type: 'text', pfx: `目的`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${_i1zrz.i1zra4100s.substring(0,30)}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;
      _lines.push({ type: 'text', pfx: `備考`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${_i1zrz._ctn.substring(0,30)}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;

      _row += 1;
      _lines.push({ type: 'text', pfx: `利用対象`,  cmn: 1, row: _row, cmnCnt: 18, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `利用時間帯`,  cmn: 19, row: _row, cmnCnt: 18, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: _gStgz.crt.S06041513 == 1 ? `利用料金等` : ' ',  cmn: 37, row: _row, cmnCnt: 18, ta: 'ctr', frm: true });

      _row += 1;
      _i1z1s.map((_i1z1z: ht.dz) => { // 部屋
        const _i10rz = hf.get1(_i1z1z?.cldz?.i10rs, {});
        _lines.push({ type: 'text', pfx: _i10rz?._pfx ?? '',  cmn: 1, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true, mln: true  });
        //_lines.push({ type: 'text', pfx: `${_i1z1z.i1z1a2200s}　${_i1z1z.i1z1a1100i}時〜${_i1z1z.i1z1a1200i}時`,  cmn: 19, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true });
        _lines.push({ type: 'text', pfx: `${_i1z1z.i1z1a2200s}`,  cmn: 19, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true });
        _lines.push({ type: 'text', pfx: _gStgz.crt.S06041513 == 1 ? ('¥' + hf.cvtCmm(_i1z1z.i1z1m1100i)) : ``,  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
        _row += 1;
      })

      _i1z2s.map((_i1z2z: ht.dz) => { // 設備
        const _i17rz = hf.get1(_i1z2z?.cldz?.i17rs, {});
        _lines.push({ type: 'text', pfx: _i17rz?._pfx ?? '',  cmn: 1, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true, mln: true  });
        _lines.push({ type: 'text', pfx: `${_i1z2z.i1z2a1100i}時〜${_i1z2z.i1z2a1200i}時`,  cmn: 19, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true });
        _lines.push({ type: 'text', pfx: _gStgz.crt.S06041513 == 1 ? ('¥' + hf.cvtCmm(_i1z2z.i1z2m1100i)) : ` `,  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
        _row += 1;
      })
      _row -= 1;

      if (_gStgz.crt.S06041513 == 1 && _i1z3z.i1z3m3100i > 0) {
        _row += 1;
        _lines.push({ type: 'text', pfx: `その他支払額（${_i1z3z.i1z3a1100s}）`,  cmn: 1, row: _row, cmnCnt: 36, rowCnt: 1, ta: 'rht', frm: true });
        _lines.push({ type: 'text', pfx: '¥' + hf.cvtCmm(_i1z3z.i1z3m3100i),  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
      }

      if (_gStgz.crt.S06041513 == 1 && _i1z3z.i1z3m2100i > 0) {
        _row += 1;
        _lines.push({ type: 'text', pfx: `減免額`,  cmn: 1, row: _row, cmnCnt: 36, rowCnt: 1, ta: 'rht', frm: true });
        _lines.push({ type: 'text', pfx: '- ¥' + hf.cvtCmm(_i1z3z.i1z3m2100i),  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
      }

      if (_gStgz.crt.S06041513 == 1) {
        _row += 1;
        _lines.push({ type: 'text', pfx: `支払額合計`,  cmn: 1, row: _row, cmnCnt: 36, rowCnt: 1, ta: 'rht', frm: true });
        _lines.push({ type: 'text', pfx: '¥' + hf.cvtCmm(_i1z3z.i1z3m4100i),  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
      }

//      _row = 39;
      _row = 30;
      if (hf.f(_gStgz.crt.S06041412)) _lines.push({ type: 'img', url: _gStgz.crt.S06041412,  x: -7, row: _row, rowCnt: 7});

      _lines.push({ type: 'pstCvsToPdf' });
      _lines.push({ type: 'clrCvs' });
      _lines.push({ type: 'addNewPageToPdf' });

      if (hf.f(_gStgz.crt.S06041432)) {
        _row = 0;
        _lines.push({ type: 'img', url: _gStgz.crt.S06041432,  x: -7, row: _row, rowCnt: 7});
        _lines.push({ type: 'pstCvsToPdf' });
        _lines.push({ type: 'clrCvs' });
        _lines.push({ type: 'addNewPageToPdf' });
      }

      _row = 0;
      _lines.push({ type: 'text', pfx: `第２号様式`,  cmn: 1, row: _row, rowCnt: 1, ts: 0.8, });

      _row += 1;
      _lines.push({ type: 'text', pfx: `${_gStgz.crt.S06041331 ?? ''}　利用許可証`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 2, ta: 'ctr', frm: false, ts: 1.2, tb: true });

      _row += 3;
      //hf.l(`icvI1z___Ez 40: ${_i1zrz._icn}`)
      _lines.push({ type: 'text', pfx: `予約ID: ${_i1zrz._icn}`,  cmn: 1, row: _row, rowCnt: 1, });
      _lines.push({ type: 'text', pfx: `申込日: ${hfDTM.f(_i1zrz.i1zrd2100s, '年月日', false)}`,  cmn: 36, row: _row, cmnCnt: 19, ta: 'rht', rowCnt: 1, });

/*
      _row += 2;
      String(_gStgz.crt.S06041111).split(/\n/).map( _frmMsg1 => {
        _lines.push({ type: 'text', pfx: _frmMsg1,  cmn: 1, row: _row, tc: _gStgz.crt.S06041121 });
        _row += 1;
      });
*/
      _row += 2;
      String(_gStgz.crt.S06041211).split(/\n/).map( _frmMsg2 => {
//      hf.l(`icvI1z___Ez 64: ${_frmMsg2}`)
        //_lines.push({ type: 'text', pfx: _frmMsg2,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 1, ta: 'ctr', tc: _gStgz.crt.S06041221 });
//        _lines.push({ type: 'text', pfx: _frmMsg2,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 1, ta: 'ctr', tc: _gStgz.crt.S06041221 });
        _lines.push({ type: 'text', pfx: _frmMsg2,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 1, ta: 'left', tc: _gStgz.crt.S06041221 });
        _row += 1;
      });

      _row += 1;
      _lines.push({ type: 'text', pfx: `団体名`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${_i18rz._pfx.substring(0,30)}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;
      _lines.push({ type: 'text', pfx: `団体番号`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${_i18rz.i18rab100s}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;
/*
      _lines.push({ type: 'text', pfx: `申請者及び連絡先`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `申込者：${_i1zrz.i1zra2100s}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _lines.push({ type: 'text', pfx: `連絡先：${_i1zrz.i1zra3100s}`,  cmn: 34, row: _row, cmnCnt: 21, rowCnt: 1.5, ta: 'left', frm: false });
      _row += 1.5;
*/

      _row += 1;
      _lines.push({ type: 'text', pfx: `利用日`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${hfDTM.f(_i1zrz.i1zrd3100s, '年月日（曜日）', true)}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;
      _lines.push({ type: 'text', pfx: `目的`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${_i1zrz.i1zra4100s.substring(0,30)}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;
      _lines.push({ type: 'text', pfx: `備考`,  cmn: 1, row: _row, cmnCnt: 12, rowCnt: 1.5, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `${_i1zrz._ctn.substring(0,30)}`,  cmn: 13, row: _row, cmnCnt: 42, rowCnt: 1.5, ta: 'left', frm: true });
      _row += 1.5;

      _row += 1;
      _lines.push({ type: 'text', pfx: `利用対象`,  cmn: 1, row: _row, cmnCnt: 18, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: `利用時間帯`,  cmn: 19, row: _row, cmnCnt: 18, ta: 'ctr', frm: true });
      _lines.push({ type: 'text', pfx: _gStgz.crt.S06041513 == 1 ? `利用料金等` : ` `,  cmn: 37, row: _row, cmnCnt: 18, ta: 'ctr', frm: true });

      _row += 1;
      _i1z1s.map((_i1z1z: ht.dz) => { // 部屋
        const _i10rz = hf.get1(_i1z1z?.cldz?.i10rs, {});
        _lines.push({ type: 'text', pfx: _i10rz?._pfx ?? '',  cmn: 1, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true, mln: true  });
        //_lines.push({ type: 'text', pfx: `${_i1z1z.i1z1a2200s}　${_i1z1z.i1z1a1100i}時〜${_i1z1z.i1z1a1200i}時`,  cmn: 19, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true });
        _lines.push({ type: 'text', pfx: `${_i1z1z.i1z1a2200s}`,  cmn: 19, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true });
        _lines.push({ type: 'text', pfx: _gStgz.crt.S06041513 == 1 ? ('¥' + hf.cvtCmm(_i1z1z.i1z1m1100i)) : ` `,  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
        _row += 1;
      })

      _i1z2s.map((_i1z2z: ht.dz) => { // 設備
        const _i17rz = hf.get1(_i1z2z?.cldz?.i17rs, {});
        _lines.push({ type: 'text', pfx: _i17rz?._pfx ?? '',  cmn: 1, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true, mln: true  });
        _lines.push({ type: 'text', pfx: `${_i1z2z.i1z2a1100i}時〜${_i1z2z.i1z2a1200i}時`,  cmn: 19, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'left', frm: true });
        _lines.push({ type: 'text', pfx: _gStgz.crt.S06041513 == 1 ? ('¥' + hf.cvtCmm(_i1z2z.i1z2m1100i)) : ` `,  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
        _row += 1;
      })
      _row -= 1;

      if (_gStgz.crt.S06041513 == 1 && _i1z3z.i1z3m3100i > 0) {
        _row += 1;
        _lines.push({ type: 'text', pfx: `その他支払額（${_i1z3z.i1z3a1100s}）`,  cmn: 1, row: _row, cmnCnt: 36, rowCnt: 1, ta: 'rht', frm: true });
        _lines.push({ type: 'text', pfx: '¥' + hf.cvtCmm(_i1z3z.i1z3m3100i),  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
      }

      if (_gStgz.crt.S06041513 == 1 && _i1z3z.i1z3m2100i > 0) {
        _row += 1;
        _lines.push({ type: 'text', pfx: `減免額`,  cmn: 1, row: _row, cmnCnt: 36, rowCnt: 1, ta: 'rht', frm: true });
        _lines.push({ type: 'text', pfx: '- ¥' + hf.cvtCmm(_i1z3z.i1z3m2100i),  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
      }

      if (_gStgz.crt.S06041513 == 1) {
        _row += 1;
        _lines.push({ type: 'text', pfx: `支払額合計`,  cmn: 1, row: _row, cmnCnt: 36, rowCnt: 1, ta: 'rht', frm: true });
        _lines.push({ type: 'text', pfx: '¥' + hf.cvtCmm(_i1z3z.i1z3m4100i),  cmn: 37, row: _row, cmnCnt: 18, rowCnt: 1, ta: 'rht', frm: true });
      }

      _row += 2;
      String(_gStgz.crt.S06041311).split(/\n/).map( _frmMsg3 => {
        _lines.push({ type: 'text', pfx: _frmMsg3,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 1, ta: 'left', tc: _gStgz.crt.S06041321});
        _row += 1;
      });

      if (_gStgz.crt.S06041513 == 1) {

        _row = 33;

        _lines.push({ type: 'line', cmn1: 0, row1: _row, cmn2: 52, row2: _row, dss: [2,2] });

        _row += 1;
        _lines.push({ type: 'text', pfx: `領収書`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 2, ta: 'ctr', frm: false, ts: 1.2, tb: true });

        _row += 2;
        _lines.push({ type: 'text', pfx: `予約ID: ${_i1zrz._icn}`,  cmn: 1, row: _row, rowCnt: 1, });
        _lines.push({ type: 'text', pfx: `${hfDTM.f(hf.f(_i1z3z.i1z3d2100s) ? _i1z3z.i1z3d2100s : _i1zrz.i1zrd3100s, '年月日', false)}`,  cmn: 36, row: _row, cmnCnt: 19, ta: 'rht', rowCnt: 1, });

        _row += 2;
        _lines.push({ type: 'text', pfx: `団体名：${_i18rz._pfx.substring(0,30)} 様`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 1.5, ta: 'left', frm: false, ts: 1 });
        _lines.push({ type: 'line', cmn1: -1, row1: _row+1, cmn2: 35, row2: _row+1, bw:1, });

        _row += 2.5;
        _lines.push({ type: 'text', pfx: '¥ ' + hf.cvtCmm(_i1z3z.i1z3m4100i),  cmn: 1, row: _row, cmnCnt: 30, rowCnt: 1.5, ta: 'rht', frm: false, ts: 1.6 });
        _lines.push({ type: 'text', pfx: `（内消費税 ${hf.cvtCmm(hf.cvtFlr(_i1z3z.i1z3m4100i/1.1*0.1))}円 【適用税率 10%】）`,  cmn: 31, row: _row, cmnCnt: 23, rowCnt: 1.5, ta: 'left', frm: false, ts: 0.8 });
        _lines.push({ type: 'line', cmn1: 17, row1: _row+1, cmn2: 30, row2: _row+1, bw:1, });

        _row += 2;
        _lines.push({ type: 'text', pfx: `但し、${hfDTM.f(_i1zrz.i1zrd3100s, '年月日（曜日）', false)} の施設利用料として領収いたしました。`,  cmn: 6, row: _row, cmnCnt: 48, rowCnt: 1, ta: 'rht', ts: 0.8 });

        _row += 0.8;
        if (hf.f(_gStgz.crt.S06041422))_lines.push({ type: 'img', url: _gStgz.crt.S06041422,  cmn:25, row: _row, cmnCnt: 25});

      }

      _lines.push({ type: 'pstCvsToPdf' });
      _lines.push({ type: 'clrCvs' });
      if ( _i1zrIdx != pz.i1zr_fsts.length - 1) {
        _lines.push({ type: 'addNewPageToPdf' });
      }

      return true;
    }
  )))

  _lines.push({ type: 'grtUrl' });
//  _lines.push({ type: 'savePdf' });

  const _url = await cmPDF.dwlFileAsync({
    lines: _lines,
    itlz: {
      orientation: 'portrait',
    },
    fileName: '利用申請書',
  }) as ht.s;

  //hf.l(`icvI1z___Ez 201: ${_url}`);

  return _url;

};

/*
export const eptExlAsync1 = async (pz: { // 予約一覧
  ctt: 'e' | 'r', // content
  i1zrs: ht.ls,
}) => { // 予約一覧

  const _fileName = `予約一覧_${hfDTM.f(hfDTM.getTdy(), 'YYYYMMDD')}.xlsx`;

  const _shtName = '予約一覧';

  const _hdrs = [
    { key: 1100, header: 'No', width: 5, style: {} },
    { key: 1200, header: '予約ID', width: 5, style: {} },
    { key: 1300, header: '状況', width: 5, style: {} },
    { key: 1400, header: '団体番号', width: 5, style: {} },
    { key: 1500, header: '団体名', width: 20, style: {} },
    { key: 1600, header: '利用日', width: 10, style: {} },
    { key: 1700, header: '利用部屋', width: 20, style: {} },
    { key: 1800, header: '利用時間帯', width: 20, style: {} },
    { key: 1900, header: '利用料', width: 10, style: {} },
    { key: 2000, header: '利用料受領日', width: 10, style: {} },
    { key: 2100, header: '目的', width: 20, style: {} },
    { key: 2200, header: '備考', width: 20, style: {} },
  ];

  let _bdys = [] as ht.ls;
  pz.i1zrs.filter((_i1zrz: ht.dz) => (
    (pz.ctt == 'r' && _i1zrz.i1zrs1100i >= 80) || 
    (pz.ctt == 'e' && _i1zrz.i1zrs1200i >= 80)
  )).map((_i1zrz: ht.dz, _i1zrIdx: ht.n) => {
    const _i18rz = _i1zrz?.cldz?.i18r[0];
    //hf.l(`icvI1z___Ez 395: ${hf.s(_i18rz)}`)
    const _i1z3z = _i1zrz?.cldz?.i1z3[0];
    _bdys.push({
      1100: _i1zrIdx + 1,
      1200: _i1zrz._icn,
      1300: 
        pz.ctt == 'r' ? 
          ihd.r(ihd.f('i1zrs1100i').ls, _i1zrz.i1zrs1100i)
        : pz.ctt == 'e' ? 
          ihd.r(ihd.f('i1zrs1200i').ls, _i1zrz.i1zrs1200i)
        : '',
      1400: _i18rz.i18rab100s,
      1500: _i18rz._pfx,
      1600: hfDTM.f(_i1zrz.i1zrd3100s, '年月日曜'),
      1700: _i1zrz.i1zra1100s,
      1800: _i1zrz.i1zra1200s,
      1900: _i1z3z.i1z3m1110i,
      2000: _i1z3z.i1z3d2100s,
      2100: _i1zrz.i1zra4100s,
      2200: _i1zrz._ctn,
    });
  });

  hfXLS.saveAsync({
    fileName: _fileName,
    shts: [
      {
        shtName: _shtName,
        hdrs: _hdrs,
        bdys: _bdys,
      }
    ]
  })

};
*/
